import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { EjdfComponent } from './features/ejdf/ejdf.component';
import { IrtaComponent } from './features/irta/irta.component';
import { CreateComponent } from './features/rta/create/create.component';
import { DatailsComponent } from './features/rta/datails/datails.component';
import { EditComponent } from './features/rta/edit/edit.component';
import { HomeComponent } from './features/home/home.component';
import { BitwitComponent } from './features/bitwit/bitwit.component';
import { AdminComponent } from './features/admin/admin.component';
import { EmailDesignerComponent } from './features/admin/email-designer/email-designer.component';
import { SettingsComponent } from './features/settings/settings.component';
import { ApprovalActionComponent } from './features/rta/approval-action/approval-action.component';
import { MsalGuard, MsalRedirectComponent } from '@azure/msal-angular';

const routes: Routes = [
  // Auth callback route - required for MSAL redirect flow
  { path: 'auth', component: MsalRedirectComponent },
  { path: '', component: HomeComponent },
  { path: 'rtaapp', component: HomeComponent },
  { path: 'create', redirectTo: '/edit', pathMatch: 'full' },
  { path: 'edit', component: EditComponent },
  { path: 'edit/:id', component: EditComponent },
  { path: 'ejdf/:id', component: EjdfComponent },
  { path: 'irta', component: IrtaComponent },
  { path: 'irta/:id', component: IrtaComponent },
  { path: 'details/:id', component: DatailsComponent },
  { path: 'dashboard', component: DashboardComponent },
  { path: 'bitwit', component: BitwitComponent },
  { path: 'admin', component: AdminComponent },
  { path: 'admin/email-designer', component: EmailDesignerComponent },
  { path: 'admin/email-designer/:id', component: EmailDesignerComponent },
  { path: 'settings', component: SettingsComponent },
  { path: 'approval/:token', component: ApprovalActionComponent },
  { path: 'details', redirectTo: '/home', pathMatch: 'full' },
  { path: 'ejdf', redirectTo: '/dashboard', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
